import { AxiosResponse } from 'axios';
import { acceptMappingSolution, mappingProblemList } from '@/api/mappingProblem';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams } from '@/types';
import { IAcceptMappingSolutionParams, IMappingProblemApiListResponse, IMappingProblemFilters } from '@/types/mappingProblem';

export const mappingProblemService = {
    async list(params: IListParams<IMappingProblemFilters>): Promise<AxiosResponse<IMappingProblemApiListResponse>> {
        try {
            return await baseListService<IMappingProblemApiListResponse>(mappingProblemList, params);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('MappingProblem API Error:', e);
            throw new AppError('Unable to load mapping problem list, request error', { cause: e });
        }
    },

    async accept(params: IAcceptMappingSolutionParams): Promise<AxiosResponse<{ success: boolean }>> {
        try {
            return await acceptMappingSolution(params);
        } catch (e) {
            console.error('MappingProblem Accept API Error:', e);
            throw new AppError('Unable to accept mapping solution, request error', { cause: e });
        }
    },
};
